export default {
  'posList.name': 'Hệ thống bán hàng',
};
